import React from 'react';
import { Select, FormControl, FormHelperText } from '@material-ui/core';
import PropTypes from 'prop-types';
import InputBase from '@material-ui/core/InputBase';
import { withStyles } from '@material-ui/core/styles';

const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
      borderRadius: 28,
    },
    icon: {
      backgroundColor: '#0073a8',
      borderRadius: 28,
    },
  },

  input: {
    maxWidth: '25em',
    borderRadius: 28,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 28,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

export const CustomSelectField = ({
  input,
  label,
  symbol,
  meta: { touched, error },
  children,
  ...custom
}) => {
  return (
    <FormControl error={touched && error}>
      <br />
      <div>
        <b> {label}</b>
      </div>
      <Select
        native
        {...input}
        {...custom}
        label={symbol}
        input={<BootstrapInput />}
      >
        onChange={(event, index, value) => input.onChange(value)}
        {children}
      </Select>
      <br />
      {renderFromHelper({ touched, error })}
    </FormControl>
  );
};
const renderFromHelper = ({ touched, error }) => {
  if (!(touched && error)) {
    return;
  } else {
    return <FormHelperText>{touched && error}</FormHelperText>;
  }
};

CustomSelectField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  label: PropTypes.string,
  children: PropTypes.array,
  symbol: PropTypes.string,
};
